import { useCallback, useEffect, useRef, useState } from 'react';

import { isBrowser } from '../utils/isBrowser.util';

const useResize = (): { isResizing: boolean } => {
	const timerResize = useRef<NodeJS.Timeout | number>();
	const [isResizing, setIsResizing] = useState<boolean>(false);

	// Info(Katia): Debounce resize
	const handleResize = useCallback(() => {
		if (isResizing) {
			setIsResizing(false);
		}

		clearTimeout(timerResize.current as number);

		// Info (Katia): Changing the timer will affect lock/unlock behaviour on ipad
		timerResize.current = setTimeout(() => {
			setIsResizing(true);
		}, 300);
	}, [isResizing]);

	useEffect(() => {
		if (!isBrowser) {
			return;
		}

		window.addEventListener('resize', handleResize);
		window?.screen?.orientation
			? window.screen.orientation.addEventListener('change', handleResize)
			: window.addEventListener('orientationchange', handleResize);

		return () => {
			if (!isBrowser) {
				return;
			}

			window.removeEventListener('resize', handleResize);
			window?.screen?.orientation
				? window.screen.orientation.removeEventListener(
						'change',
						handleResize,
				  )
				: window.removeEventListener('orientationchange', handleResize);
			clearTimeout(timerResize.current as number);
		};
	}, [handleResize]);

	return {
		isResizing,
	};
};

export default useResize;
